import { render, staticRenderFns } from "./wxcode.vue?vue&type=template&id=f0dc6fa2&scoped=true&"
import script from "./wxcode.vue?vue&type=script&lang=js&"
export * from "./wxcode.vue?vue&type=script&lang=js&"
import style0 from "./wxcode.vue?vue&type=style&index=0&id=f0dc6fa2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0dc6fa2",
  null
  
)

export default component.exports